"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMediaQuery;

var _reactResizeDetector = require("react-resize-detector");

function useMediaQuery(_ref) {
  var _ref$md = _ref.md,
      md = _ref$md === void 0 ? 0 : _ref$md,
      _ref$lg = _ref.lg,
      lg = _ref$lg === void 0 ? 99999 : _ref$lg;

  var _useResizeDetector = (0, _reactResizeDetector.useResizeDetector)(),
      width = _useResizeDetector.width,
      ref = _useResizeDetector.ref; // console.log('useMediaQuery sizes', sizes);
  // const { width } = sizes;


  var mq = {
    sm: width <= md,
    md: width > md && width <= lg,
    mdMinus: width <= lg,
    mdPlus: width > md,
    lg: width > lg
  };
  return [ref, mq];
}

;